import { styled } from 'styled-components';
import { textExtraTinyNormal, textSmallSemiBold } from '../../Typography';
import { Popover } from '@mantine/core';

export const LabelContainer = styled.button`
  ${textExtraTinyNormal};
  padding: var(--space-50);
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full);
  border: 1px solid var(--border-color-default);

  &.skin_default {
    color: var(--text-standard-secondary);
    background: var(--button-background);
    border-color: var(--border-color-secondary);
  }

  &.skin_brand {
    color: var(--text-primary-dark);
    background: var(--turquoise-400);
    border-color: var(--turquoise-500);
  }
`;
